export default "__VITE_ASSET__CYISjICn__"